export function calculateQuickSelectValues(
  min: number,
  max: number,
  options: { includeMin?: boolean } | undefined = {
    includeMin: false,
  }
): number[] {
  const { includeMin } = options;
  if (min === 0 && max === 100 && !includeMin) {
    return [25, 50, 75, 100];
  }
  const diff = max - min;

  if (diff < 3) {
    return [];
  }
  if (diff === 3 || diff === 4 || diff === 5) {
    return Array.from({ length: Math.min(diff + 1, 5) }, (_, index) =>
      // For 6 elements, show last as max/min
      diff === 5 && index === 4 && includeMin
        ? max
        : min + index + (diff === 5 && !includeMin ? 1 : 0)
    );
  }

  const totalCount = 5;
  const count = includeMin ? totalCount - 1 : totalCount;
  const step = diff / count;
  const list = [
    ...(includeMin ? [min] : []),
    ...Array.from(
      { length: includeMin ? totalCount - 1 : totalCount },
      (_, index) =>
        index === count - 1
          ? max
          : Math.round(min + step * (index + (includeMin ? 1 : 1)))
    ),
  ];
  // console.log({ min, max, includeMin, list });

  const roundAt = (value: number, precision: number) => {
    const roundedUncorrected = Math.round(value / precision) * precision;
    return Math.min(max, Math.max(min, roundedUncorrected));
  };

  const roundingPrecision = 5;
  const diff5 =
    roundAt(list[2], roundingPrecision) - roundAt(list[1], roundingPrecision);
  if (diff5 > 0) {
    return list.map((value, index) =>
      (includeMin && index === 0) || index == totalCount - 1
        ? value
        : roundAt(value, 5)
    );
  }
  // no rounding if values too close
  return list;
}
